import React, { useContext, useState, useCallback } from 'react';
import { Button, Markdown } from '@superops/ui-design-system';
import {
  getTranslatedText,
  convertMarkdownToHtml,
  useActivityTracker
} from '@nile/components';
import { useIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import TabContext from '@nile/mangifera/src/Contexts/TicketContext';
import {
  CREATE_ARTICLE_ID,
  KB_ARTICLE_MODULE
} from '@nile/rmm/src/modules/knowledge-base/helper/constants';
import DislikeCard from '../AIRecommendedSoutions/DislikeCard';
import { isEmpty } from 'lodash';
import { useAIStore } from '@nile/components/src/Components/AI/store/aiStore';
import { dompurifier } from '@nile/components/src/Utils/helpers';

const AIKnowledgeBase = (props) => {
  const { content: kbContent } = props;
  const { content, title } = kbContent;
  const intl = useIntl();
  const tabContext = useContext(TabContext);
  const [showDislike, setShowDislike] = useState(false);

  const setShowRatingComponent = useAIStore((s) => s.setShowRatingComponent);

  const dislike = useCallback(() => {
    setShowDislike(true);
    useActivityTracker({
      event: 'AI_Knowledge_base - Clicked Dislike'
    });
  }, []);

  const handleCreateKBArticle = () => {
    setShowRatingComponent(true);

    useActivityTracker({
      event: 'GENERATED_KB_ARTICLE_FROM_SIMILAR_TICKETS'
    });

    const htmlText = convertMarkdownToHtml(content);
    tabContext.openTab({
      module: KB_ARTICLE_MODULE,
      url: `/kb/article/${CREATE_ARTICLE_ID}/create`,
      state: {
        article: {
          name: title
        },
        content: htmlText
      },
      data: {
        id: CREATE_ARTICLE_ID
      }
    });
  };

  if (showDislike) {
    return <DislikeCard />;
  }

  if (isEmpty(content) || content === 'NOT_ENOUGH_CONTENT') {
    return (
      <div className="ai-dark-bg p10 br10">
        {getTranslatedText(intl, 'ai.kb.create.article.insufficient.data')}
      </div>
    );
  }

  return (
    <>
      <div className="fx col actr max-height-60vh scroll">
        <div className="p10 mb-10 br10 kb-ai-markdown ai-dark-bg min-height-350 scroll">
          <Markdown disallowedElements={['br']}>
            {dompurifier(content)}
          </Markdown>
        </div>
      </div>
      <div className="flex actr g10 w100 mt15 pl5 pr5">
        <div className="w100 ai-button-big-bg">
          <Button
            aiPrimary
            icon={<SVGIcon name="AIWand" size="sm" />}
            size="slim"
            fullWidth
            onClick={handleCreateKBArticle}
          >
            <div className="fsize12">
              {getTranslatedText(intl, 'ai.kb.create.article.label')}
            </div>
          </Button>
        </div>
        <Button aiSecondary size="tiny" aiOutline onClick={dislike}>
          <div className="flex">
            <SVGIcon name="ThumbsDownOutline" />
          </div>
        </Button>
      </div>
    </>
  );
};

export default AIKnowledgeBase;
